export interface IAuth {
  uid?: string;
  role?: Roles;
  token?: string;
}

export enum ErrorTypes {
  NETWORK_ERROR = "NETWORK_ERROR",
  AUTHENTICATION_ERROR = "AUTHENTICATION_ERROR",
  TICKET_NOT_FOUND_ERROR = "TICKET_NOT_FOUND_ERROR",
  ERROR_CODE_409 = "409"
}

export enum Roles {
  OWNER = "OWNER",
  RECIPIENT = "RECIPIENT"
}

export enum ShareOptions {
  email = "email",
  sms = "sms"
}

export enum ShareStatus {
  Init = "Init",
  Requested = "Requested",
  Accepted = "Accepted",
  Rejected = "Rejected",
  Cancelled = "Cancelled",
  GivenBack = "GivenBack",
  Recalled = "Recalled",
  ErrorStatus = "ErrorStatus"
}

export enum AuthEndpoints {
  Login = "login",
  Signup = "signup"
}

export interface IError {
  type: ErrorTypes;
  message: string;
}

export interface IRemoteData<T> {
  loading: boolean;
  data?: T | undefined;
  error?: IError | undefined;
}

export interface IVenueInfo {
  eventName: string;
  eventDescription: string;
  venueName: string;
  state: string;
  when: string;
  productId: string;
}

export interface ISeatInfo {
  sectionNumber: number;
  rowNumber: number;
  seatNumber: number;
}

export interface IPriceInfo {
  priceInCent: number;
  priceCategory: string;
}

export interface ITicketInfoBase {
  ticketGroupId: string;
  ticketId: string;
  venueInfo: IVenueInfo;
  seatInfo: ISeatInfo;
  shareStatus: ShareStatus;
  role: Roles;
}

export interface IOwnerTicketInfo extends ITicketInfoBase {
  sharedTo?: string;
}

export interface IRecipientTicketInfo extends ITicketInfoBase {
  sharedFrom?: string;
}

export interface IRecipientExtraInfo {
  checkReceive: boolean;
}

export interface ITicketReceiveState
  extends IRemoteData<IRecipientTicketInfo>,
    IRecipientExtraInfo {
  postStep?: string;
  firstAccepted?: boolean;
  otherAttribute?: boolean;
}

export interface IEnvironment {
  BASE_PROXY_URL:string,
  NODE_ENV:string,
  REGION: string;
  HOMEPAGE_URL: string;
  ORDER_HISTORY_URL :string;
  COLLECTION_STATEMENT_URL: string;
  TERMS_CONDITIONS_URL: string;
  PRIVACY_POLICY_URL: string;
  PURKLE_COLLECTION_STATEMENT_URL: string;
  PURKLE_TERMS_CONDITIONS_URL: string;
  PURKLE_PRIVACY_POLICY_URL: string;
  COMPANY_INFO: string;
  FORGOT_PASSWORD_URL: string;
  IOS_APP_STORE_LINK: string;
  GOOGLE_PLAY_APP_LINK: string;
  PREFERRED_COUNTRIES: string;
  SHARE_OPTIONS: any[];
}